
import Info from './Information/Index.vue'
import EditInfo from './Information/Edit.vue'

import RoomTypeList from './RoomType/List.vue'
import RoomTypeAdd from './RoomType/Add.vue'
import RoomTypeEdit from './RoomType/Edit.vue'

import RateCodeList from './RateCode/List.vue'
import RateCodeAdd from './RateCode/Add.vue'
import RateCodeEdit from './RateCode/Edit.vue'
import RateCodeRemark from './RateCode/Remark.vue'

import PromotionList from './Promotion/List.vue'
import PromotionAdd from './Promotion/Add.vue'
import PromotionEdit from './Promotion/Edit.vue'
import PromotionRemark from './Promotion/Remark.vue'

import TransferList from './Transfer/List.vue'
import TransferAdd from './Transfer/Add.vue'
import TransferEdit from './Transfer/Edit.vue'
import TransferRemark from './Transfer/Remark.vue'

import HotelRemark from './Remark/Index.vue'
import HotelRemarkEdit from './Remark/Edit.vue'

import HotelTermsAndConditions from './TermsAndConditions/Index.vue'
import HotelTermsAndConditionsEdit from './TermsAndConditions/Edit.vue'

import SupplementRoute from './Supplement/router'
import HotelEmailConfiguration from './EmailConfiguration/Edit'

export default [
  {
    path: 'info',
    name: 'HotelInfo',
    component: Info
  },
  {
    path: 'info/edit',
    name: 'EditHotelInfo',
    props: true,
    component: EditInfo
  },
  {
    path: 'room-type',
    name: 'HotelRoomTypeList',
    component: RoomTypeList
  },
  {
    path: 'room-type/add',
    name: 'HotelRoomTypeAdd',
    component: RoomTypeAdd
  },
  {
    path: 'room-type/edit',
    name: 'HotelRoomTypeEdit',
    props: true,
    component: RoomTypeEdit
  },
  {
    path: 'rate-code',
    name: 'HotelRateCodeList',
    props: true,
    component: RateCodeList
  },
  {
    path: 'rate-code/add',
    name: 'HotelRateCodeAdd',
    props: true,
    component: RateCodeAdd
  },
  {
    path: 'rate-code/edit',
    name: 'HotelRateCodeEdit',
    props: true,
    component: RateCodeEdit
  },
  {
    path: 'rate-code/remark',
    name: 'HotelRateCodeRemark',
    props: true,
    component: RateCodeRemark
  },
  {
    path: 'promotion',
    name: 'HotelPromotionList',
    component: PromotionList
  },
  {
    path: 'promotion/add',
    name: 'HotelPromotionAdd',
    props: true,
    component: PromotionAdd
  },
  {
    path: 'promotion/edit',
    name: 'HotelPromotionEdit',
    props: true,
    component: PromotionEdit
  },
  {
    path: 'promotion/remark',
    name: 'HotelPromotionRemark',
    props: true,
    component: PromotionRemark
  },
  {
    path: 'supplement',
    component: () => import(/* webpackChunkName: "SupplementCharge" */ '@/views/Hotel/ManageHotel/Supplement/Index.vue'),
    children: SupplementRoute
  },
  {
    path: 'transfer',
    name: 'HotelTransferList',
    component: TransferList
  },
  {
    path: 'transfer/add',
    name: 'HotelTransferAdd',
    component: TransferAdd
  },
  {
    path: 'transfer/edit',
    name: 'HotelTransferEdit',
    props: true,
    component: TransferEdit
  },
  {
    path: 'transfer/remark',
    name: 'HotelTransferRemark',
    props: true,
    component: TransferRemark
  },
  {
    path: 'remark',
    name: 'HotelRemark',
    component: HotelRemark
  },
  {
    path: 'remark/edit',
    name: 'HotelRemarkEdit',
    props: true,
    component: HotelRemarkEdit
  },
  {
    path: 'terms-conditions',
    name: 'HotelTermsAndConditions',
    component: HotelTermsAndConditions
  },
  {
    path: 'terms-conditions/edit',
    name: 'HotelTermsAndConditionsEdit',
    props: true,
    component: HotelTermsAndConditionsEdit
  },
  {
    path: 'email-configuration',
    name: 'HotelEmailConfiguration',
    component: HotelEmailConfiguration
  }
]
